<template>
    <b-navbar centered shadow>

        <template #start>
            <div>
                <b-navbar-item tag="div" transparent>

                    <b-autocomplete style="width:500px !important" icon-pack="fas" icon="fas fa-search"
                        :data="productData" placeholder="Search Product..." field="title" :loading="isFetching"
                        @typing="searchProduct" @select="option => showProductDetails(option)">

                        <template slot-scope="props">
                            <div class="media">
                                <div class="media-left">
                                    <img width="32"
                                        :src="props.option.product_image">
                                </div>
                                <div class="media-content">
                                    <span class="has-text-weight-medium is-size-7">Code : <b>{{ props.option.product_id }}</b> </span>
                                    <br>
                                    <b>{{ props.option.product_name }}</b>
                                    <br>
                                    <small>
                                       {{ props.option.family_name }}
                                    </small>
                                </div>
                            </div>
                        </template>
                        <template #empty>No products found</template>
                    </b-autocomplete>
                </b-navbar-item>
            </div>
        </template>
        <template #end>
            <b-navbar-item tag="div" transparent>
                <div class="navbar-item has-dropdown is-hoverable">
                    <a class="navbar-link  is-arrowless">
                        <b-icon pack="fas" icon="fas fa-cog" type="is-dark"></b-icon>
                    </a>

                    <div class="navbar-dropdown is-boxed is-right is-hoverable is-arrowless">
                        <b-navbar-item tag="div">
                            <div class="has-text-centered">
                                <div style="padding:5px;">
                                    <span style="margin:5px"
                                        class=" has-text-black is-size-5 has-text-weight-bold">Settings</span>
                                </div>

                                <div style="margin:5px 15px 5px 15px">
                                    <b-button style="width:150px;" type="is-danger" icon-pack="fas"
                                        icon-left="fas fa-sign-out-alt" @click="logout" expanded>
                                        Logout
                                    </b-button>
                                </div>
                            </div>
                        </b-navbar-item>
                    </div>

                </div>
            </b-navbar-item>
        </template>
    </b-navbar>
</template>

<script>
import ShowProductDetails from '@/components/ShowProductDetails.vue'
export default {
    data() {
        return {
            productData:[],
            isFetching:false
        }
    },
    methods: {
        searchProduct(input){
            this.isFetching = true
            if(input){

        this.$store.dispatch('searchProduct', input)
        .then((response)=>{
          this.productData = []
        this.productData.push(...response.result.product_data)
        
        })
        .catch(() => {
        this.ToastError('Problem searching products')
      })
      .finally(() => {
          this.isFetching = false
      })
      }
      
        },
        logout() {
            this.$store.dispatch("logout");
            this.$router.push({
                name: "home"
            });
        },
        showProductDetails(product_details){
        this.$buefy.modal.open({
          parent: this,
          component: ShowProductDetails,
          props:{product_details: product_details},
          hasModalCard: true,
          trapFocus: true,
          canCancel:['x'],
        })
        }
    }
}
</script>

<style>
.wrap{
  display: inline-block;
  position: relative;
}
.stacked{
  position: absolute;
  top: 5px;
  left: 25px;
}

</style>